export default {
    /**过滤查询所有网络设置信息 */
    listFilterNetworkSettings(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkAreaSetting/listFilterNetworkSettings', params, response);
    },
    /**查询所有网络设置信息 */
    listNetworkSettings(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/listNetworkSettings', params, response);
    },
    /**添加网络设置信息 */
    addNetworkSettings(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/addNetworkSettings', params, response);
    },
    /**修改网络设置信息 */
    updateNetworkSettings(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/updateNetworkSettings', params, response);
    },
    /**根据id删除网络设置信息 */
    deleteNetworkSettingsById(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/deleteNetworkSettingsById', params, response);
    },
    /**根据网络设置sId获取网络服务信息 */
    listNetworkServiceBySttingsId(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/listNetworkServiceBySttingsId', params, response);
    },
    /**添加网络服务信息 */
    addNetworkService(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/addNetworkService', params, response);
    },
    /**修改网络服务信息 */
    updateNetworkService(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/updateNetworkService', params, response);
    },
    /**根据sId删除网络服务信息 */
    deleteNetworkServiceById(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkSetting/deleteNetworkServiceById', params, response);
    },
    /**查询所有局域网网络设置信息 */
    queryNetworkAreaSettingList(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkAreaSetting/queryNetworkAreaSettingList', params, response);
    },
    /**查询网络配置黑白名单id */
    queryNetworkAreaWhiteBlackList(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkAreaSetting/queryNetworkAreaWhiteBlackList', params, response);
    },
    /**查询网络配置黑白名单对象 */
    showNetworkAreaWhiteBlackList(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkAreaSetting/showNetworkAreaWhiteBlackList', params, response);
    },
    /**配置页面获取树形中间件 */
    queryMiddlewareTreeForNoPlugin(params, response) {
        window.vue.$apiAxios.get('/device/middleware/queryMiddlewareTreeForNoPlugin', params, response);
    },
    /**新增网络配置 */
    saveNetworkAreaSetting(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkAreaSetting/saveNetworkAreaSetting', params, response);
    },
    /**更新网络配置黑白名单 */
    updateNetworkAreaWhiteBlackList(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkAreaSetting/updateNetworkAreaWhiteBlackList', params, response);
    },
    /**删除网络配置 */
    /**根据id删除网络设置信息 */
    delNetworkAreaWhiteBlack(params, response) {
        window.vue.$apiAxios.postRequestBody('/networkAreaSetting/delNetworkAreaWhiteBlack', params, response);
    }
};
